// extracted by mini-css-extract-plugin
export default {"mobile_nav_wrapper":"Gj","mobile_nav":"Hj","link":"Ij","link_name":"Jj","active":"Kj"};
    if(module.hot) {
      // 1714654863396
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  